import {GET_LIST} from 'react-admin';

/**
 * Decorator for messages related requests
 *
 * @param requestHandler
 * @returns {function(...[*]=)}
 */
export const messagesDecorator = requestHandler => (type, resource, params) => {
    if (resource !== 'messages') {
        return requestHandler(type, resource, params);
    }

    if (type === GET_LIST) {
        params = applyDefaultArchiveFilter(params);
    }

    return requestHandler(type, resource, params);
};

/**
 * Make sure the inArchive filter is always set
 *
 * @param params
 * @returns {*}
 */
const applyDefaultArchiveFilter = (params) => {
    const {filter} = params;

    if (!filter.hasOwnProperty('inArchive')) {
        params.filter['inArchive'] = false;
    }

    if (!filter.hasOwnProperty('privacy')) {
        params.filter['privacy'] = {
            value: 'private',
        };
    }

    return params;
};
